"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TailwindLegacyWrapper = exports.default = void 0;
var TailwindLegacyWrapper_1 = require("./TailwindLegacyWrapper");
// eslint-disable-next-line no-restricted-exports
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return TailwindLegacyWrapper_1.TailwindLegacyWrapper; } });
Object.defineProperty(exports, "TailwindLegacyWrapper", { enumerable: true, get: function () { return TailwindLegacyWrapper_1.TailwindLegacyWrapper; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxpRUFJaUM7QUFIL0IsaURBQWlEO0FBQ2pELGdIQUFBLHFCQUFxQixPQUFXO0FBQ2hDLDhIQUFBLHFCQUFxQixPQUFBIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/tailwind-legacy-wrapper/index.js
// module id = 2396
// module chunks = 25